<template>
    <div class="h-auth-login bg-primary" v-bind:style="backgroundStyle">
        <div class="h-layout h-layout-full-height h-layout-auth">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-xl-4">
                        <card-auth>
                            <div class="my-4"></div>

                            <div v-show="errorMessage" class="alert alert-danger mb-6" v-html="errorMessage"></div>

                            <form @submit.prevent="$_recaptcha_verify(login)">
                                <form-group label="E-mail" labelFor="loginEmail" :error="formErrors.email">
                                    <input type="email" id="loginEmail" class="form-control" spellcheck="false" tabindex="1" autocomplete="email" autofocus v-model="formData.email">
                                </form-group>

                                <form-group class="mb-1" label="Senha" labelFor="loginPassword" :error="formErrors.password">
                                    <input type="password" id="loginPassword" class="form-control" tabindex="2" autocomplete="current-password" v-model="formData.password">
                                </form-group>

                                <div class="d-sm-flex justify-content-sm-between mb-4">
                                    <p class="mb-0 mt-sm-0 ml-auto pr-3 text-sm font-weight-semibold">
                                        <router-link to="/auth/reset-password" tabindex="5">
                                            Esqueceu sua senha?
                                        </router-link>
                                    </p>
                                </div>

                                <div class="text-center mt-6">
                                    <button-form ref="btnLogin" type="submit" theme="success" class="btn-lg btn-block" tabindex="4">Entrar</button-form>
                                </div>
                            </form>

                            <div class="text-center mt-6">
                                <span class="text-sm font-weight-semibold">Ainda não possui uma conta?</span><br>
                                <router-link to="/auth/register" class="text-lg font-weight-bold" tabindex="6">Cadastre-se agora!</router-link>
                            </div>

                            <div class="text-center mt-6">
                                <p class="mb-2 text-sm font-weight-semibold">Ou acesse usando suas redes sociais:</p>
                                <nav-social />
                            </div>

                            <vue-recaptcha
                                v-if="recaptchaKey"
                                ref="recaptcha"
                                size="invisible"
                                :sitekey="recaptchaKey"
                                :loadRecaptchaScript="true"
                                @verify="$_recaptcha_onVerified"
                                @expired="$_recaptcha_onExpired" />
                        </card-auth>
                    </div>

                    <div class="col-lg">
                        <div class="row align-items-centers ml-lg-5">
                            <div class="col-12 col-sm-6 col-lg-12 col-xl-6">
                                <div v-if="article.title && article.link" class="h-auth-login--content p-4 p-sm-0 pl-sm-5 pb-sm-5 p-lg-0">
                                    <h2 class="mb-6">
                                        {{ article.title }}
                                    </h2>
                                    <h5 v-if="article.subtitle" class="mb-6" v-html="article.subtitle"></h5>
                                    <p class="mb-5" v-if="article.content" v-html="article.content"></p>
                                    <a class="btn btn-primary btn-block" :href="article.link" target="_blank">
                                        {{ article.linkLabel || 'Saiba mais' }}
                                    </a>
                                </div>
                            </div>

                            <div class="d-none d-sm-flex d-lg-none d-xl-flex col-6">
                                <img class="img-fluid d-block" v-if="auxImage" :src="auxImage" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import VueRecaptcha   from 'vue-recaptcha'
    import recaptcha      from '@/mixins/recaptcha'
    import util           from '@/mixins/util'
    import ButtonForm     from '@/components/atoms/ButtonForm'
    import FormGroup      from '@/components/molecules/FormGroup'
    import LoginBlogPost  from '@/components/molecules/LoginBlogPost'
    import NavSocial      from '@/components/molecules/NavSocial'
    import CardAuth       from '@/components/organisms/CardAuth'
    import ErrorService   from '@/services/error.service'

    export default {
        mixins: [
            recaptcha,
            util
        ],
        components: {
            FormGroup,
            LoginBlogPost,
            CardAuth,
            NavSocial,
            ButtonForm,
            VueRecaptcha
        },
        data() {
            return {
                formData: {},
                formErrors: {},
                errorMessage: "",
                recaptchaKey: "",

                bgColor: "",
                bgImage: "",
                auxImage: "/images/auth/img-revenda.min.png",
                article: {
                    title: "Uma poderosa plataforma para você vender mais",
                    subtitle: "Novo painel de revenda da Hostoo",
                    content: "Automatize processos que demandam tempo e dinheiro, tenha mais disponibilidade para cuidar do seu negócio e cresça, sem aumentar os custos operacionais!",
                    link: "https://hostoo.io/revenda?utm_source=login_page&utm_medium=button_cta&utm_campaign=novo_painel_revenda",
                    linkLabel: "Saiba mais",
                },
            }
        },
        computed: {
            backgroundStyle: function()
            {
                const style = {};

                if (this.bgColor) {
                    style["backgroundColor"] = this.bgColor;
                }

                if (this.bgImage) {
                    style["backgroundImage"] = `url("${this.bgImage}")`;
                }

                return style;
            }
        },
        created()
        {
            this.recaptchaKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;

            if (this.$route.query.email) {
                this.$set(this.formData, 'email', this.$route.query.email);
            }

            if (this.$route.query.oauth_email_unavailable)
            {
                this.errorMessage = 'O e-mail vinculado a esta rede social já está sendo usado em uma conta. ' +
                    'Faça login com o e-mail e associe a rede social à sua conta nas configurações do perfil.';
            }

            if (this.$route.query.oauth_access_denied) {
                this.errorMessage = 'Não foi possível fazer login com a rede social informada.';
            }

            // Domínio para registro
            if (this.$route.query.domain && /^([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9][a-zA-Z0-9\-]+\.[a-zA-Z]{2,13}?$/.test(String(this.$route.query.domain))) {
                this.$cookie.set('hos_domain', this.$route.query.domain, { expires: '15m' });
            }
        },
        methods: {
            ...mapActions({
                loginUser: 'user/login',
                showErrorAlert: 'alert/error'
            }),

            fetchContent()
            {
                this.$api.get(`/campaign/login`, { timeout: 500 })
            },

            /**
             * Fazer login do usuário.
             */
            login()
            {
                this.$refs.btnLogin.loadingFocus();
                this.formErrors = {};
                this.errorMessage = '';

                const { email, password } = this.formData;

                this.loginUser({ email, password, captcha: this.$_recaptcha_token })
                    .then (response => {
                        // Verificação de telefone
                        if (response.data.data.phoneVerification) {
                            this.$router.push({ path: '/auth/verification/phone', query: { token: response.data.data.token } });
                            return;
                        }

                        // Verificação 2FA
                        // TODO: [Matheus] Verificar se esta informação pode ficar salva na memória em caso de erros.
                        if (response.data.data.twoFactorVerification)
                        {
                            localStorage.setItem('user_authetication', JSON.stringify({
                                "email"          : email,
                                "password"       : password,
                                "recaptcha_token": this.$_recaptcha_token
                            }));

                            const param = this.$route.query.redirect ? `?redirect=${this.$route.query.redirect}` : "";

                            this.$router.push({ path: `/auth/verification/2fa${param}` });

                            return;
                        }

                        if (response.data.data.partnerSurvey) {
                            window.location.href = "/become-partner";
                        }

                        let redirectUrl = "/";

                        if (this.$route.query.redirect) {
                            redirectUrl = this.killXSS(this.$route.query.redirect);
                        }

                        window.location.href = redirectUrl;
                    })
                    .catch(error => {
                        const status = error.response.status || 0;

                        if (status === 422) {
                            ErrorService.handleFormError(error, this);
                        }
                        else if (status >= 400 && typeof error.response.data.message !== 'undefined') {
                            this.errorMessage = error.response.data.message;
                        }
                        else {
                            this.showErrorAlert(error);
                        }

                        this.$refs.btnLogin.setLoading(false);
                        this.$refs.recaptcha.reset();
                    })
            }
        }
    }
</script>

<style lang="stylus">
    .h-auth-login {
        //background-color $primary
        //background-size cover
        //background-repeat none
        background: linear-gradient(180deg, #15004C 0%, #0B0028 50%, #09001E 100%);

        .h-layout-auth {
            max-width 1600px
            margin 0 auto
        }

        .h-m-login-blog-post {
            max-width none
        }
    }

    .h-auth-login--content {
        line-height 1.375
        color white

        @media (min-width 992px) {
            font-size 1.125rem
        }

        h2 {
            font-weight 800
            line-height 1.125

            @media (min-width 992px) {
                font-size 3em
                line-height 1
            }
        }

        h5 {
            font-size 1.375em
        }

        p {
            font-weight 300
        }

        .btn-block {
            max-width 480px
            font-size 1.125em
            border 0
            background linear-gradient(270deg, #f76707, #5900ff)

            &:hover {
                background linear-gradient(270deg, #c24e02, #4400c2)
            }
        }
    }
</style>
